<div class="edit-container">
    <h1 class="edit-title">Actualizează relație</h1>
    <form class="edit-card__form" [formGroup]="form" (submit)="submitForm()">
        <div class="row">
            <div class="col">
                <mat-form-field class="w-100" appearance="fill">
                    <mat-label>Tip relație</mat-label>
                    <mat-select formControlName="relationship_type_id" (openedChange)="onRelatieTypeClosed()">
                        <mat-form-field class="px-2 sticky-input">
                            <input matInput [formControl]="relatieTypeControl" (keydown)="$event.stopPropagation()"
                                (click)="$event.stopPropagation()" />
                        </mat-form-field>
                        <mat-option *ngIf="filteredRelatieType.length === 0" disabled>
                            <span>Nu au fost găsite rezultate</span>
                        </mat-option>

                        <mat-option *ngFor="let item of filteredRelatieType" [value]="item.id">
                            {{ item.name }}
                        </mat-option>
                    </mat-select>
                    <mat-error
                        *ngIf="!form.controls['relationship_type_id'].valid && form.controls['relationship_type_id'].touched">
                        Selectați o opțiune
                    </mat-error>
                </mat-form-field>
            </div>
        </div>

        <div class="row">
            <div class="col">
                <mat-form-field class="w-100" appearance="fill">
                    <mat-label>Grad rudenie</mat-label>
                    <mat-select formControlName="relationship_specific_id" (openedChange)="onRelatieSpecificaClosed()">
                        <mat-form-field class="px-2 sticky-input">
                            <input matInput [formControl]="relatieSpecificaControl" (keydown)="$event.stopPropagation()"
                                (click)="$event.stopPropagation()" />
                        </mat-form-field>
                        <mat-option *ngIf="filteredRelatieSpecifica.length === 0" disabled>
                            <span>Nu au fost găsite rezultate</span>
                        </mat-option>

                        <mat-option *ngFor="let item of filteredRelatieSpecifica" [value]="item.id">
                            {{ item.name }}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
            </div>
        </div>

        <div class="row">
            <div class="col">
                <mat-form-field class="w-100" appearance="fill">
                    <mat-label>Status relație</mat-label>
                    <mat-select formControlName="relationship_status_id" (openedChange)="onRelatieStatusClosed()">
                        <mat-form-field class="px-2 sticky-input">
                            <input matInput [formControl]="relatieStatusControl" (keydown)="$event.stopPropagation()"
                                (click)="$event.stopPropagation()" />
                        </mat-form-field>

                        <mat-option *ngIf="filteredRelatieStatus.length === 0" disabled>
                            <span>Nu au fost găsite rezultate</span>
                        </mat-option>

                        <mat-option *ngFor="let item of filteredRelatieStatus" [value]="item.id">
                            {{ item.name }}
                        </mat-option>
                    </mat-select>
                    <mat-error
                        *ngIf="!form.controls['relationship_status_id'].valid && form.controls['relationship_status_id'].touched">
                        Selectați o opțiune
                    </mat-error>
                </mat-form-field>
            </div>
        </div>

        <div class="row">
            <div class="col">
                <mat-form-field class="w-100" appearance="fill">
                    <mat-label>Confirmare relație</mat-label>
                    <mat-select formControlName="relationship_confirmation_status_id"
                        (openedChange)="onConfirmareRelatieClosed()">
                        <mat-form-field class="px-2 sticky-input">
                            <input matInput [formControl]="confirmareRelatieControl"
                                (keydown)="$event.stopPropagation()" (click)="$event.stopPropagation()" />
                        </mat-form-field>

                        <mat-option *ngIf="filteredConfirmareRelatie.length === 0" disabled>
                            <span>Nu au fost găsite rezultate</span>
                        </mat-option>

                        <mat-option *ngFor="let item of filteredConfirmareRelatie" [value]="item.id">
                            {{ item.name }}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
            </div>
        </div>

        <div class="row">
            <div class="col-md-12">
                <mat-form-field appearance="fill">
                    <mat-label>Observații</mat-label>
                    <textarea matInput formControlName="observatii" name="observatii"></textarea>
                </mat-form-field>
            </div>
        </div>

        <div class="row">
            <div class="col d-flex justify-content-between">
                <button class="buttons" type="button" mat-stroked-button (click)="closeDialog()">
                    {{ helper.dialogConfig.buttonLabels.close }}
                </button>
                <button class="buttons" type="submit" mat-flat-button color="primary" [disabled]="form.invalid">
                    {{ helper.dialogConfig.buttonLabels.save }}
                </button>
            </div>
        </div>
    </form>
    <div class="section-spinner position-absolute" *ngIf="isLoading">
        <div class="spinner position-absolute top-50 start-50 translate-middle">
            <mat-spinner></mat-spinner>
            <h3 class="mt-2">{{ helper.dialogConfig.generalMessages.pleaseWait }}</h3>
        </div>
    </div>
</div>